import { sanitizeReturnTo } from './returnTo.ts';

export function buildNativeAppLink(scheme: string, returnTo: string | null): string {
  const safeReturnTo = sanitizeReturnTo(returnTo);
  if (!safeReturnTo) return scheme;

  const normalizedScheme = scheme.endsWith('://') ? scheme : `${scheme}://`;
  return `${normalizedScheme}${safeReturnTo.replace(/^\/+/, '')}`;
}
